module.exports = __webpack_public_path__ + "static/media/goldenprize-tuna-salad-lid.760673c9.png";